<template>
    <div class="contract-box">
        <div class="contract_wrap">
            <!--合同信息-->
            <div class="contract_wrap_item" style="border-bottom: none">
                <div class="contract_wrap_item_title">
                    <div class="icon"></div>
                    <span>合同信息</span>
                </div>
                <div class="contract_wrap_item_content">
                    <div class="contract_wrap_item_content_item">
                        <!--合同编号-->
                        <div class="column">
                            <div class="text" style="margin-left: -9px;min-width: 80px">
                                <span class="must">*</span>
                                <span>合同编号：</span>
                            </div>
                            <!--              <el-input placeholder="请输入" :disabled="addType==='0'?false:true" v-model="contractMsg.contractCode">-->
                            <el-input placeholder="请输入" v-model="contractMsg.contractCode">
                            </el-input>
                        </div>
                        <!--类型-->
                        <div class="column">
                            <div class="text" style="margin-left: -9px;">
                                <span class="must">*</span>
                                <span>类<span class="txthidden">占位</span>型：</span>
                            </div>
                            <el-select v-model="contractMsg.contractType" placeholder="请选择" class="select" :disabled="isdisabled" @change="getcontractType">
                                <el-option v-for="item in contractType" :key="item.value" :label="item.valueDesc" :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                        <!--签约人-->
                        <div class="column">
                            <div class="text" style="margin-left: -9px;min-width: 80px">
                                <span class="must">*</span>
                                <span>签&nbsp;约&nbsp;&nbsp;人：</span>
                            </div>
                            <el-autocomplete class="select" popper-class="my-autocomplete" v-model="contractMsg.signerName" :fetch-suggestions="querySearchAsync" placeholder="请选择" @select="handleSelect">
                                <template slot-scope="{ item }">
                                    <div class="name" @select="handleSelect">{{ item.name }}</div>
                                </template>
                            </el-autocomplete>
                        </div>
                        <!--签约日期-->
                        <div class="column">
                            <div class="text" style="margin-left: -9px;min-width: 80px">
                                <span class="must">*</span>
                                <span>签约日期：</span>
                            </div>
                            <el-date-picker value-format="yyyy-MM-dd" v-model="contractMsg.signDate" type="date" placeholder="请选择">
                            </el-date-picker>
                        </div>
                        <!--交房时间-->
                        <div class="column">
                            <div class="text">
                                <span>交房时间：</span>
                            </div>
                            <!--              <el-date-picker value-format="yyyy-MM-dd" v-model="contractMsg.handoverDate" type="date"-->
                            <!--                placeholder="请选择"></el-date-picker>-->
                            <el-input style="width: 250px" placeholder="请输入" v-model="contractMsg.handoverDate">
                            </el-input>
                        </div>
                    </div>
                    <div class="contract_wrap_item_content_item">
                        <!--房源编号-->
                        <div class="column">
                            <div class="text" style="padding: 2.5px 0;">
                                <span>房源编号：</span>
                                <span>{{contractMsg.houseCode}}</span>
                                <i v-if="concractFrom==='contracList'" style="color:#5E75E6 ;margin-left: 30px" class="iconfont icon-icon_xinzeng_da" @click="clickGethouse"></i>
                            </div>
                        </div>
                        <!--建筑面积-->
                        <div class="column">
                            <div class="text"><span>建筑面积：</span></div>
                            <div>{{contractMsg.floorSpace}}</div>
                        </div>
                        <!--产权证号-->
                        <div class="column">
                            <div class="text"><span>产权证号：</span></div>
                            <div>{{contractMsg.titleCertificate}}</div>
                        </div>
                        <!--房源地址-->
                        <div class="column">
                            <div class="text"><span>房源地址：</span></div>
                            <div>{{contractMsg.houseAddr}}</div>
                        </div>
                        <!--产权地址-->
                        <div class="column">
                            <div class="text"><span>产权地址：</span></div>
                            <el-input placeholder="请输入" v-model="contractMsg.propertyAddress"></el-input>
                        </div>
                    </div>
                    <div class="contract_wrap_item_content_item">
                        <!--合同模板-->
                        <div class="column">
                            <div class="text" style="margin-left: -9px;">
                                <span class="must">*</span>
                                <span>合同模板：</span>
                            </div>
                            <el-select v-model="contractMsg.templateId" placeholder="请选择" class="select" @visible-change="getTemplate">
                                <el-option v-for="item in contractTemplate" :key="item.id" :label="item.name" :value="item.id">
                                </el-option>
                            </el-select>
                        </div>
                        <!--成交金额-->
                        <div class="column">
                            <div class="text" style="margin-left: -9px;min-width: 80px">
                                <span class="must">*</span>
                                <span>成交金额：</span>
                            </div>
                            <el-input placeholder="请输入" v-model="contractMsg.finalPrice"></el-input>
                            <span class="danwei" v-if="typeShow">万元</span>
                            <span class="danwei" v-if="sentShow">元</span>
                        </div>
                        <!---付款方式-->
                        <div class="column">
                            <div class="text" style="margin-left: -9px;">
                                <span class="must">*</span>
                                <span>付款方式：</span>
                            </div>
                            <el-select v-model="contractMsg.paymentMethod" placeholder="请选择" class="select" @visible-change="getPayway">
                                <el-option v-for="item in payWay" :key="item.value" :label="item.valueDesc" :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                        <!--税费承担-->
                        <div class="column" v-if="typeShow">
                            <div class="text"><span>税费承担：</span></div>
                            <el-input placeholder="请输入" v-model="contractMsg.taxFee"></el-input>
                        </div>
                        <!--租房起租日期-->
                        <div class="column" v-show="sentShow">
                            <div class="text">
                                <span>起租日期：</span>
                            </div>
                            <el-date-picker value-format="yyyy-MM-dd" v-model="contractMsg.startRentDate" type="date" placeholder="请选择"></el-date-picker>
                        </div>
                        <!--租房截止日期-->
                        <div class="column" v-show="sentShow">
                            <div class="text">
                                <span>截止日期：</span>
                            </div>
                            <el-date-picker value-format="yyyy-MM-dd" v-model="contractMsg.endRentDate" type="date" placeholder="请选择">
                            </el-date-picker>
                        </div>
                    </div>
                    <div class="contract_wrap_item_content_item">
                        <!--业主佣金-->
                        <div class="column">
                            <div class="text"><span>业主佣金：</span></div>
                            <el-input placeholder="请输入" v-model="contractMsg.sellerCommission"></el-input>
                            <span class="danwei">元</span>
                        </div>
                        <!--业主优惠-->
                        <div class="column">
                            <div class="text"><span>业主优惠：</span></div>
                            <el-input placeholder="请输入" v-model="contractMsg.ownerPreference"></el-input>
                            <span class="danwei">元</span>
                        </div>
                        <!--客户佣金-->
                        <div class="column">
                            <div class="text"><span>客户佣金：</span></div>
                            <el-input placeholder="请输入" v-model="contractMsg.buyerCommission"></el-input>
                            <span class="danwei">元</span>
                        </div>
                        <!--客户优惠-->
                        <div class="column">
                            <div class="text"><span>客户优惠：</span></div>
                            <el-input placeholder="请输入" v-model="contractMsg.customerPreference"></el-input>
                            <span class="danwei">元</span>
                        </div>
                        <!--定金-->
                        <div class="column">
                            <div class="text"><span>定<span class="txthidden">占位</span>金：</span></div>
                            <el-input placeholder="请输入" v-model="contractMsg.deposit"></el-input>
                            <span class="danwei">元</span>
                        </div>
                    </div>
                    <div class="contract_wrap_item_content_item">
                        <!--贷款手续费-->
                        <div class="column" v-if="typeShow">
                            <div class="text" style="min-width: 85px"><span>贷款手续费：</span></div>
                            <el-input placeholder="请输入" v-model="contractMsg.loanProcedures" style="width: 158px"></el-input>
                            <span class="danwei">元</span>
                        </div>
                        <!--付款详情-->
                        <div class="column" style="width: 80%;">
                            <div class="text"><span>付款详情：</span></div>
                            <el-input style="width: 100%" placeholder="请输入" v-model="contractMsg.payDetail"></el-input>
                        </div>
                    </div>
                    <div class="contract_wrap_item_content_item">
                        <!--备注-->
                        <div class="column" style="width: 100%;align-items: initial">
                            <div class="text" style="padding-top: 8px;">
                                <span>备<span class="txthidden">占位</span>注：</span>
                            </div>
                            <el-input placeholder="请输入" type="textarea" :rows="3" v-model="contractMsg.remarks"></el-input>
                        </div>
                    </div>
                    <div class="contract_wrap_item_content_item">
                        <!--附件-->
                        <div class="column" style="width: 100%;align-items: initial">
                            <div class="text"><span>附<span class="txthidden" style="min-width: 70px">占位</span>件：</span></div>
                            <ul class="model_info_list">
                                <div class="model_info_list_box" style="display: flex;justify-content: flex-start;max-width: 1300px;overflow-x: auto;overflow-y: hidden">
                                    <li class="model_info_list_item upload_img_box" style="margin-right: 10px;" v-for="(item,index) in contractMsg.picAddress" :key="index" @click="setCurImg(index)">
                                        <div class="model_info_img">
                                            <img style="width: 100px;height: 100px;border-radius: 6px;" :src="'http://' + item" />
                                        </div>
                                    </li>
                                    <li class="model_info_list_item upload_img_box" style="border: 1px dashed #d9d9d9;border-radius: 6px;cursor: pointer;" @click="openUploadImg">
                                        <i class="el-icon-plus avatar-uploader-icon"></i>
                                    </li>
                                </div>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <!--业主信息-->
            <div class="contract_wrap_item" style="border-bottom: none">
                <div class="contract_wrap_item_title">
                    <div class="icon"></div>
                    <span>业主信息</span>
                </div>
                <div class="contract_wrap_item_content">
                    <div class="contract_wrap_item_content_item">
                        <div class="contract_wrap_item_content_item_title">业主</div>
                        <div class="contract_wrap_item_content_item_msg">
                            <div class="contract_wrap_item_content_item_msg_item">
                                <!--姓名-->
                                <div class="column">
                                    <div class="text" style="margin-left: -9px;">
                                        <span class="must">*</span>
                                        <span>姓<span class="txthidden">占位</span>名：</span>
                                    </div>
                                    <div>{{contractMsg.ownerName}}</div>
                                </div>
                                <!--证件号-->
                                <div class="column zhengjian">
                                    <div class="text" style="margin-left: -9px;">
                                        <span class="must">*</span>
                                        <span>证&nbsp;件&nbsp;号：</span>
                                    </div>
                                    <el-select v-model="contractMsg.ownerCardType" placeholder="请选择" class="select" disabled>
                                        <el-option v-for="item in certificatesType" :key="item.value" :label="item.valueDesc" :value="item.value"></el-option>
                                    </el-select>
                                    <div>{{contractMsg.ownerCard}}</div>
                                    <!--                                    <el-input class="number" placeholder="请输入" v-model="contractMsg.ownerCard"></el-input>-->
                                </div>
                                <!--地址-->
                                <div class="column">
                                    <div class="text">
                                        <span>地<span class="txthidden">占位</span>址：</span>
                                    </div>
                                    <!--                 <el-input class="address" placeholder="请输入" v-model="contractMsg.communicationAddr"></el-input>-->
                                    <div>{{contractMsg.communicationAddr}}</div>
                                </div>
                                <!--电话-->
                                <div class="column">
                                    <div class="text" style="margin-left: -9px;">
                                        <span class="must">*</span>
                                        <span>电<span class="txthidden">占位</span>话：</span>
                                    </div>
                                    <div>{{contractMsg.ownerPhone}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="contract_wrap_item_content_item">
                        <div class="contract_wrap_item_content_item_title">共有人</div>
                        <div class="contract_wrap_item_content_item_msg">
                            <div class="contract_wrap_item_content_item_msg_item" v-for="(item,index) in contractMsg.partOwnerInfo" :key="index">
                                <!--姓名-->
                                <div class="column">
                                    <div class="text">
                                        <span>姓<span class="txthidden">占位</span>名：</span>
                                    </div>
                                    <div>{{item.name}}</div>
                                </div>
                                <!--证件号-->
                                <div class="column zhengjian">
                                    <div class="text">
                                        <span>证&nbsp;件&nbsp;号：</span>
                                    </div>
                                    <el-select v-model="item.idType" placeholder="请选择" class="select zhengjian" disabled>
                                        <el-option v-for="item in certificatesType" :key="item.value" :label="item.valueDesc" :value="item.value"></el-option>
                                    </el-select>
                                    <div>{{item.idNumber}}</div>
                                </div>
                                <!--地址-->
                                <div class="column">
                                    <div class="text">
                                        <span>地<span class="txthidden">占位</span>址：</span>
                                    </div>
                                    <div>{{item.address}}</div>
                                </div>
                                <!--电话-->
                                <div class="column">
                                    <div class="text">
                                        <span>电<span class="txthidden">占位</span>话：</span>
                                    </div>
                                    <div>{{item.phone.join(',')}}</div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="contract_wrap_item_content_item">
                        <div class="contract_wrap_item_content_item_title">委托人</div>
                        <div class="contract_wrap_item_content_item_msg">
                            <div class="contract_wrap_item_content_item_msg_item">
                                <!--姓名-->
                                <div class="column">
                                    <div class="text">
                                        <span>姓<span class="txthidden">占位</span>名：</span>
                                    </div>
                                    <el-input placeholder="请输入" v-model="contractMsg.clientName"></el-input>
                                </div>
                                <!--证件号-->
                                <div class="column zhengjian">
                                    <div class="text">
                                        <span>证&nbsp;件&nbsp;号：</span>
                                    </div>
                                    <el-select v-model="contractMsg.clientCardType" placeholder="请选择" class="select  zhengjian">
                                        <el-option v-for="item in certificatesType" :key="item.value" :label="item.valueDesc" :value="item.value"></el-option>
                                    </el-select>
                                    <el-input class="number" placeholder="请输入" v-model="contractMsg.clientCard"></el-input>
                                </div>
                                <!--地址-->
                                <div class="column">
                                    <div class="text">
                                        <span>地<span class="txthidden">占位</span>址：</span>
                                    </div>
                                    <el-input class="address" placeholder="请输入" v-model="contractMsg.ownerClientAddr"></el-input>
                                </div>
                                <!--电话-->
                                <div class="column">
                                    <div class="text">
                                        <span>电<span class="txthidden">占位</span>话：</span>
                                    </div>
                                    <!--                                    <div>{{contractMsg.ownerClientPhone}}</div>-->
                                    <div style="overflow-x: auto;">
                                        <span class="addPhone" style="margin-right: 10px;" :key="index" v-for="(item,index) in contractMsg.ownerClientPhone">
                                            <el-input style="margin-right: 5px;" placeholder="请输入电话" v-model="contractMsg.ownerClientPhone[index]" class="input-iphone" @blur="setTestphone(index,contractMsg.ownerClientPhone)"></el-input>
                                            <i :class="index === 0 ? 'el-icon-plus':'el-icon-close'" @click="deletePhone(index,contractMsg.ownerClientPhone)" style="color: #ffffff;background: #5E75E6;border-radius: 50%;width: 15px;height: 15px;text-align: center;line-height: 15px;font-size: 12px"></i>
                                        </span>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--客户信息-->
            <div class="contract_wrap_item">
                <div class="contract_wrap_item_title">
                    <div class="icon"></div>
                    <span>客户信息</span>
                </div>
                <div class="contract_wrap_item_content">
                    <div class="contract_wrap_item_content_item">
                        <div class="contract_wrap_item_content_item_title">客户</div>
                        <div class="contract_wrap_item_content_item_msg">
                            <div class="contract_wrap_item_content_item_msg_item">
                                <!--客户编号-->
                                <div class="column">
                                    <div class="text" style="margin-left: -9px;">
                                        <span class="must">*</span>
                                        <span>客户编号：</span>
                                    </div>
                                    <div>{{contractMsg.customerCode}}</div>
                                    <i style="color:#5E75E6 ;margin-left: 30px" class="iconfont icon-icon_xinzeng_da" @click="clickGetcustomer"></i>
                                </div>
                                <!--证件号-->
                                <div class="column zhengjian">
                                    <div class="text" style="margin-left: -9px;">
                                        <span class="must">*</span>
                                        <span>证&nbsp;件&nbsp;号：</span>
                                    </div>
                                    <el-select v-model="contractMsg.customerCardType" placeholder="请选择" class="select" disabled>
                                        <el-option v-for="item in certificatesType" :key="item.value" :label="item.valueDesc" :value="item.value"></el-option>
                                    </el-select>
                                    <div>{{contractMsg.customerCard}}</div>
                                    <!--                                    <el-input class="number" placeholder="请输入" v-model="contractMsg.customerCard"></el-input>-->
                                </div>
                                <!--客户等级-->
                                <div class="column">
                                    <div class="text">
                                        <span>客户等级：</span>
                                    </div>
                                    <div>{{contractMsg.customerDegree}}</div>
                                </div>
                                <!--客户来源-->
                                <div class="column">
                                    <div class="text">
                                        <span>客户来源：</span>
                                    </div>
                                    <div>{{contractMsg.customerSourceName}}</div>
                                </div>
                            </div>
                            <div class="contract_wrap_item_content_item_msg_item">
                                <!--客户姓名-->
                                <div class="column">
                                    <div class="text" style="margin-left: -9px;">
                                        <span class="must">*</span>
                                        <span>客户姓名：</span>
                                    </div>
                                    <div>{{contractMsg.customerName}}</div>
                                </div>
                                <!--婚姻-->
                                <div class="column zhengjian">
                                    <div class="text">
                                        <span>婚<span class="txthidden">占位</span>姻：
                                        </span>
                                    </div>
                                    <el-select v-model="contractMsg.customerMarriage" placeholder="请选择" class="select">
                                        <el-option v-for="item in marriage" :key="item.value" :label="item.valueDesc" :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>
                                <!--地址-->
                                <div class="column">
                                    <div class="text">
                                        <span>地<span class="txthidden">占位</span>址：</span>
                                    </div>
                                    <el-input class="address" placeholder="请输入" v-model="contractMsg.customerAddr"></el-input>
                                </div>
                                <!--电话-->
                                <div class="column">
                                    <div class="text" style="margin-left: -9px;">
                                        <span class="must">*</span>
                                        <span>电<span class="txthidden">占位</span>话：
                                        </span>
                                    </div>
                                    <div>{{contractMsg.customerPhone}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="contract_wrap_item_content_item">
                        <div class="contract_wrap_item_content_item_title">共有人</div>
                        <div class="contract_wrap_item_content_item_msg">
                            <div class="contract_wrap_item_content_item_msg_item">
                                <!--客户姓名-->
                                <div class="column">
                                    <div class="text">
                                        <span>姓<span class="txthidden">占位</span>名：</span>
                                    </div>
                                    <el-input placeholder="请输入" v-model="contractMsg.jointName"></el-input>
                                </div>
                                <!--证件号-->
                                <div class="column zhengjian">
                                    <div class="text">
                                        <span>证&nbsp;件&nbsp;号：</span>
                                    </div>
                                    <el-select v-model="contractMsg.cusJointCardType" placeholder="请选择" class="select">
                                        <el-option v-for="item in certificatesType" :key="item.value" :label="item.valueDesc" :value="item.value"></el-option>
                                    </el-select>
                                    <el-input class="number" placeholder="请输入" v-model="contractMsg.customerJointCard"></el-input>
                                </div>
                                <!--地址-->
                                <div class="column">
                                    <div class="text">
                                        <span>地<span class="txthidden">占位</span>址：</span>
                                    </div>
                                    <el-input class="address" placeholder="请输入" v-model="contractMsg.customerJoinAddr"></el-input>
                                </div>
                                <!--电话-->
                                <div class="column">
                                    <div class="text">
                                        <span>电<span class="txthidden">占位</span>话：</span>
                                    </div>
                                    <div style="overflow-x: auto">
                                        <span class="addPhone" style="margin-right: 10px;" :key="index" v-for="(item,index) in contractMsg.customerJointPhone">
                                            <el-input style="margin-right: 5px;" placeholder="请输入电话" v-model="contractMsg.customerJointPhone[index]" class="input-iphone" @blur="setTestphone(index,contractMsg.customerJointPhone)"></el-input>
                                            <i :class="index === 0 ? 'el-icon-plus':'el-icon-close'" @click="deletePhone(index,contractMsg.customerJointPhone)" style="color: #ffffff;background: #5E75E6;border-radius: 50%;width: 15px;height: 15px;text-align: center;line-height: 15px;font-size: 12px"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="contract_wrap_item_content_item">
                        <div class="contract_wrap_item_content_item_title">委托人</div>
                        <div class="contract_wrap_item_content_item_msg">
                            <div class="contract_wrap_item_content_item_msg_item">
                                <!--姓名-->
                                <div class="column">
                                    <div class="text">
                                        <span>姓<span class="txthidden">占位</span>名：</span>
                                    </div>
                                    <el-input placeholder="请输入" v-model="contractMsg.customerJoint"></el-input>
                                </div>
                                <!--证件号-->
                                <div class="column zhengjian">
                                    <div class="text">
                                        <span>证&nbsp;件&nbsp;号：</span>
                                    </div>
                                    <el-select v-model="contractMsg.customerJointCardType" placeholder="请选择" class="select">
                                        <el-option v-for="item in certificatesType" :key="item.value" :label="item.valueDesc" :value="item.value"></el-option>
                                    </el-select>
                                    <el-input class="number" placeholder="请输入" v-model="contractMsg.cusJointCard"></el-input>
                                </div>
                                <!--地址-->
                                <div class="column">
                                    <div class="text">
                                        <span>地<span class="txthidden">占位</span>址：</span>
                                    </div>
                                    <el-input class="address" placeholder="请输入" v-model="contractMsg.customerClientAddr"></el-input>
                                </div>
                                <!--电话-->
                                <div class="column">
                                    <div class="text">
                                        <span>电<span class="txthidden">占位</span>话：</span>
                                    </div>
                                    <div style="overflow-x: auto">
                                        <span class="addPhone" style="margin-right: 10px;" :key="index" v-for="(item,index) in contractMsg.cusJointPhone">
                                            <el-input style="margin-right: 5px;" placeholder="请输入电话" v-model="contractMsg.cusJointPhone[index]" class="input-iphone" @blur="setTestphone(index,contractMsg.cusJointPhone)"></el-input>
                                            <i :class="index === 0 ? 'el-icon-plus':'el-icon-close'" @click="deletePhone(index,contractMsg.cusJointPhone)" style="color: #ffffff;background: #5E75E6;border-radius: 50%;width: 15px;height: 15px;text-align: center;line-height: 15px;font-size: 12px"></i>
                                        </span>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        </div>
        <!--房源-->
        <el-dialog width="900px" style="margin-top: 15px;" :visible.sync="innerVisible2" append-to-body>
            <div class="newintention-wrapper1">
                <div class="list-out">
                    <!--tab-->
                    <div class="list-out-tab">
                        <span v-bind:class="{ active:index===isActive1}" @click="ClassChang1(index)" v-for="(item,index) in tabData1" :key="index">{{item}}</span>
                    </div>
                    <!--搜索-->
                    <div class="header">
                        <div class="header-select">
                            <!--关键字-->
                            <div class="header-select-input">
                                <!--                <el-input v-model="input" placeholder="请输入小区名称"></el-input>-->
                                <el-autocomplete popper-class="my-autocomplete" v-model="ResidentialName" :fetch-suggestions="querySearchAsync1" placeholder="请输入小区名称" @select="handleSelect1" @clear="clearArea" clearable>
                                    <template slot-scope="{ item }">
                                        <div class="name" @select="handleSelect">{{ item.name }}</div>
                                    </template>
                                </el-autocomplete>
                            </div>
                            <button class="query btn" v-if="isActive1===0" @click="pageNumber1=1,pageSize1=10,currentPage1=1,chanceHouse1 = [],getAllHouse()">查询</button>
                            <button class="query btn" v-else @click="pageNumber1=1,pageSize1=10,currentPage1=1,chanceHouse1 = [],getCollect1()">查询</button>
                        </div>
                    </div>
                    <!--表-->
                    <div class="sales_list_wrap1">
                        <el-table :data="houseAllData1" border style="width: 100%">
                            <el-table-column width="35px">
                                <template slot-scope="scope">
                                    <el-radio-group v-model="chanceHouse1">
                                        <el-radio :label="scope.row"></el-radio>
                                    </el-radio-group>
                                </template>
                            </el-table-column>
                            <el-table-column label="房源编号">
                                <template slot-scope="scope">
                                    <span style="color: #5E75E6; border-bottom: 1px solid #5E75E6;">{{scope.row.buildingInfoId}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="residentialName" label="小区">
                            </el-table-column>
                            <el-table-column prop="houseAddress" label="地址">
                            </el-table-column>
                            <el-table-column prop="houseType" label="户型">
                            </el-table-column>
                            <el-table-column prop="structureArea" label="面积">
                            </el-table-column>
                            <el-table-column v-if="typeShow" prop="totalPrice" label="总价">
                            </el-table-column>
                            <el-table-column v-else prop="rent" label="租金">
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
                <div class="footer_page">
                    <el-pagination background @size-change="handleSizeChange1" @current-change="handleCurrentChange1" :current-page.sync="currentPage1" :page-sizes="[10, 20, 30, 40]" :page-size="8" layout="total, prev, pager, next, sizes, jumper" :total="total1">
                    </el-pagination>
                </div>
            </div>
            <!--取消、确定按钮-->
            <div class="footb">
                <button class="foot-cancel" @click="removeSaveBtn1">取消</button>
                <button v-points class="foot-save" @click="save">确定</button>
            </div>
        </el-dialog>
        <!--客源搜索-->
        <el-dialog class="customerselete" width="900px" :visible.sync="innerVisible1" append-to-body>
            <div class="newintention-wrapper1">
                <div class="list-out">
                    <!--tab-->
                    <div class="list-out-tab">
                        <span v-bind:class="{ active:index===isActive}" @click="ClassChang(index)" v-for="(item,index) in tabData" :key="index">{{item}}</span>
                    </div>
                    <!--搜索-->
                    <div class="header">
                        <div class="header-select">
                            <!--关键字-->
                            <div class="header-select-input">
                                <el-input v-model="string" placeholder="请输入姓名、电话、编号"></el-input>
                            </div>
                            <button class="query btn" @click="pageNumber=1,pageSize=10,currentPage=1,chanceHouse = [],getString()">查询</button>
                        </div>
                    </div>
                    <!--表-->
                    <div class="sales_list_wrap ">
                        <el-table :data="houseAllData" border style="width: 100%">
                            <el-table-column width="35px">
                                <template slot-scope="scope">
                                    <el-radio-group v-model="chanceHouse">
                                        <el-radio :label="scope.row"></el-radio>
                                    </el-radio-group>
                                </template>
                            </el-table-column>
                            <el-table-column label="客源编号">
                                <template slot-scope="scope">
                                    <span style="color: #5E75E6; border-bottom: 1px solid #5E75E6;">{{scope.row.cusCode}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="name" label="客户姓名"></el-table-column>
                            <el-table-column prop="phoneNumber" label="客户电话"></el-table-column>
                            <el-table-column prop="customerLevel" label="客户等级"></el-table-column>
                            <el-table-column prop="employeeName" label="经纪人"></el-table-column>
                            <el-table-column prop="entrustDate" label="录入日期"></el-table-column>
                            <el-table-column prop="source" label="来源渠道"></el-table-column>
                        </el-table>
                    </div>
                </div>
                <div class="footer_page">
                    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="8" layout="total, prev, pager, next, sizes, jumper" :total="total"></el-pagination>
                </div>
            </div>
            <!--取消、确定按钮-->
            <div class="footb">
                <button class="foot-cancel" @click="removeSaveBtn">取消</button>
                <button v-points class="foot-save" @click="save1">确定</button>
            </div>
        </el-dialog>
        <!-- 图片上传弹窗 -->
        <el-dialog v-if="uploadImgVisible" title="上传图片" width="950px" :visible.sync="uploadImgVisible" @close="closeBtn">
            <UploadImg v-if="uploadImgVisible" @cancelUpload="uploadImgVisible=false" @saveUpload="upLoadingBtn"></UploadImg>
        </el-dialog>
        <!-- 图片放大弹窗 -->
        <div class="mask" v-if="imgListShow">
            <img class="close" @click="imgListShow=false" src="../../assets/images/close.png" alt />
            <template>
                <el-carousel indicator-position="outside" :initial-index="initialIndex">
                    <el-carousel-item v-for="(item,index) in contractMsg.picAddress" :key="index">
                        <img :src="'http://'+item" alt />
                        <el-button v-points class="delet" @click="deletImg(index)" type="danger">删除</el-button>
                    </el-carousel-item>
                </el-carousel>
            </template>
        </div>
        <!--取消保存-->
        <div class="foot">
            <button class="cancel" @click="back">取消</button>
            <button v-points class="save" @click="enter">保存</button>
            <!-- <button class="save" @click="downLoadImg">图片</button> -->
        </div>
    </div>
</template>
<script >
import {
    queryCollection,
    findCustomer,
    BuyPayWay,
    RentPayWay
} from "@/api/customeManage";
import UploadImg from "@/components/common/uploadImg";
import { add, update, queryTemplate } from "@/api/contracManage";
import {
    houseTypeDetail,
    deleresidentialAreatePicture
} from "@/api/houseManage";
import { employeeQuery, communityQuery } from "@/api/manageCenter";
import { dicGet } from "@/api/index";
import { houseQuery } from "@/api/houseManage";
import { queryCollections } from "@/api/customeManage";
import {mapGetters} from "vuex";

export default {
    /* eslint-disable */
    // name: "合同编辑",
    name: "",
    components: {
        UploadImg
    },
    computed: {
      ...mapGetters(['contractType']),
    },
    data() {
        let token = sessionStorage.getItem("accessToken");
        let customerId = localStorage.getItem("customerId");
        let houseId = sessionStorage.getItem("buildId");
        let houseType = sessionStorage.getItem("houseType");
        let contractMsgs = JSON.parse(sessionStorage.getItem("contractMsg"));
        let addType = sessionStorage.getItem("contractType");
        var ketype = localStorage.getItem("ketype");
        let concractFrom = sessionStorage.getItem("concractFrom");
        return {
            concractFrom,
            ketype, //客源类型
            innerVisible2: false, //房源
            uploadImgVisible: false, //上传图片
            imgListShow: false, //图片放大删除弹框
            initialIndex: 0, //图片轮播下标
            value: [""],
            accessToken: {
                accessToken: token
            },
            customerId, //客户id
            houseId, //房源id
            houseType, //房源类型
            contractMsgs, //合同详情
            addType, //编辑添加
            imageUrl: "", //附件
            innerVisible1: false, //弹框
            typeShow: true, //根据房源状态显示(二手房)
            sentShow: false, //根据房源状态显示(租房)
            contractMsg: {
                houseCode: "", //房源编号
                floorSpace: "", //建筑面积
                titleCertificate: "", //产权证号
                houseAddr: "", //房源地址
                contractCode: "", //合同编号
                contractType: "", //类型
                signer: "", //签约人id
                signerName: "", //签约人姓名
                signDate: "", //签约日期
                templateId: "", //模板
                finalPrice: "", //成交金额
                transferDate: "", //过户日期
                startRentDate: "", //起租日期
                endRentDate: "", //结束日期
                paymentMethod: "", //付款方式
                sellerCommission: "", //卖方佣金
                buyerCommission: "", //买方佣金
                deposit: "", //定金
                paymentTransfer: "", //过户付款
                remainHousing: "", //剩余房贷
                loanProcedures: "", //贷款手续费
                remarks: "", //备注
                picAddress: [], //附件
                ownerName: "", //业主姓名
                ownerCardType: "", //业主证件类型
                ownerCard: "", //业主证件号
                ownerPhone: "", //业主电话
                ownerMarriage: "", //业主婚姻
                communicationAddr: "", //业主通讯地址
                // jointOwner: "", //业主共有人姓名
                // jointCardType: "", //业主共有人证件类型
                // jointCard: "", //业主共有人证件号
                // jointPhone: "", //业主共有人电话
                partOwnerInfo: [
                    {
                        name: "",
                        phone: [],
                        idType: "",
                        idNumber: "",
                        address: ""
                    }
                ],
                clientName: "", //业主委托人姓名
                clientCardType: "", //业主委托人证件类型
                clientCard: "", //业主委托人证件号
                customerCode: "", //客户编号
                customerDegree: "", //客户等级
                customerSource: "", //客户来源
                customerMarriage: "", //客户婚姻
                customerAddr: "", //客户通讯地址
                customerName: "", //客户姓名
                customerCardType: "", //客户征集类型
                customerCard: "", //客户证件号
                customerPhone: "", //客户电话
                jointName: "", //客户共有人姓名
                cusJointCardType: "", //客户共有人证件类型
                customerJointCard: "", //客户共有人证件号
                customerJointPhone: [""], //客户共有人电话
                customerJoint: "", //客户委托人姓名
                customerJointCardType: "", //客户委托人证件类型
                cusJointCard: "", //客户委托人证件号
                usrArea: "", //套内面积
                //新增
                cusJointPhone: [""], //客户委托人电话
                customerClientAddr: "", //客户委托人通讯地址
                ownerClientPhone: [""], //业主委托人电话
                ownerClientAddr: "", //业主委托人通讯地址
                customerJoinAddr: "", //客户共有人通讯地址
                // ownerJoinAddr: "" ,//业主共有人通讯地址
                handoverDate: "", //交房日期
                taxFee: "", //税费承担
                ownerPreference: "", //业主优惠
                customerPreference: "", //客户优惠
                payDetail: "", //付款详情
                propertyAddress: "" //产权地址
            }, //合同信息
            // contractType: [
            //     {
            //         value: "1",
            //         valueDesc: "出售"
            //     },
            //     {
            //         value: "2",
            //         valueDesc: "出租"
            //     }
            // ], //合同类型
            employeesData: [], //签约人
            contractTemplate: [], //合同模板
            payWay: [], //付款方式
            certificatesType: [], //证件类型
            marriage: [], //婚姻
            string: "", //客源搜索条件
            houseAllData: [], //所有客源
            chanceHouse: [], //选择客源
            housingInfo: {}, //房源详情
            currentPage: 1,
            total: 0,
            pageNumber: 1,
            pageSize: 10,
            isActive: 0,
            tabData: ["客源搜索", "我的收藏"],
            permissionLevel: "", //查询客源权限
            houseAllData1: [], //所有房源
            currentPage1: 1,
            total1: 0,
            pageNumber1: 1,
            pageSize1: 10,
            isActive1: 0,
            tabData1: ["房源搜索", "我的收藏"],
            chanceHouse1: [], //选择房源
            peikanCont: "",
            ResidentialName: "",
            residentialAreaId: "",
            isdisabled: false
        };
    },

    mounted() { },

    methods: {
        //选择类型
        getcontractType(val) {
            if (val === "1") {
                this.houseType = "SECONDHAND";
            } else if (val === "2") {
                this.houseType = "RENTING";
            } //类型
            this.isShow();
            this.contractMsg.templateId = ""; //模板
            this.contractMsg.paymentMethod = ""; //付款方式
            this.contractMsg.deposit = ""; //定金
            this.contractMsg.paymentTransfer = ""; //过户付款
            this.contractMsg.remainHousing = ""; //剩余房贷
            this.contractMsg.loanProcedures = ""; //贷款手续费
            this.contractMsg.customerCode = ""; //客户编号
            this.contractMsg.customerDegree = ""; //客户等级
            this.contractMsg.customerSourceName = ""; //客户来源
            this.contractMsg.customerName = ""; //客户姓名
            this.contractMsg.customerCardType = ""; //客户证件类型
            this.contractMsg.customerCard = ""; //客户证件号
            this.contractMsg.customerPhone = ""; //客户电话

            this.contractMsg.houseCode = ""; //房屋编号
            this.contractMsg.floorSpace = ""; //租房建筑面积
            this.contractMsg.titleCertificate = ""; //产权证号
            this.contractMsg.houseAddr = ""; //房源地址
            this.contractMsg.ownerName = ""; //业主姓名
            this.contractMsg.ownerCardType = ""; //业主证件类型
            this.contractMsg.ownerCard = ""; //业主证件号
            this.contractMsg.ownerPhone = ""; //业主电话
            // this.contractMsg.jointOwner = ""; //业主共有人姓名
            // this.contractMsg.jointCardType = ""; //业主共有人证件类型
            // this.contractMsg.jointCard = ""; //业主共有人证件号
            // this.contractMsg.jointPhone = ""; //业主共有人电话
            this.contractMsg.partOwnerInfo = [
                { name: "", phone: [], idType: "", idNumber: "", address: "" }
            ];
            this.contractMsg.usrArea = ""; //套内面积
            this.contractMsg.ownerMarriage = ""; //婚姻
        },
        //open上传图片弹窗
        openUploadImg() {
            this.uploadImgVisible = true;
        },
        //关闭上传图片弹框
        closeBtn() {
            this.contractMsg.picAddress = [];
        },
        //保存图片
        upLoadingBtn(data) {
            data.map(item => {
                if (item.uri) {
                    this.contractMsg.picAddress.push(item.uri);
                }
            });
            this.uploadImgVisible = false;
        },
        // 设置图片预览
        setCurImg(index) {
            this.initialIndex = index;
            this.imgListShow = true;
        },
        //删除图片
        deletImg(index) {
            this.contractMsg.picAddress.splice(index, 1);
            if (this.contractMsg.picAddress.length === 0) {
                this.imgListShow = false;
            }
            this.$message({
                type: "success",
                message: "删除成功"
            });
        },
        // let nweStr = e.filePaths[0].replace("'\'" , "/");
        // console.log(123,nweStr)
        // 下载图片
        downLoadImg(item) {
            sessionStorage.setItem("downImg", item);
            this.$electron.ipcRenderer.send("open-directory-dialog");
        },
        //电话验证
        setTestphone(index, val) {
            let phoneNumber = /^1[3456789]\d{9}$/;
            if (!phoneNumber.test(val[index])) {
                this.$message({
                    type: "error",
                    message: "请输入正确的手机号"
                });
                return false;
            }
        },
        //添加删除号码
        deletePhone(index, val) {
            if (index !== 0) {
                val.splice(index, 1);
            } else {
                if (val.length >= 3) {
                    this.$message({
                        type: "error",
                        message: "最多添加3个电话号码"
                    });
                } else {
                    val.push("");
                }
            }
        },
        //签约人
        querySearchAsync(queryString, cb) {
            let params = {
                name: queryString,
                status: "ENABLE"
            };

            this.$post(employeeQuery, params).then(res => {
                if (res.success) {
                    this.employeesData = res.data;
                    let restaurants = this.employeesData;
                    cb(restaurants);
                } else {
                }
            });
        },
        createStateFilter(queryString) {
            // 过滤小区关键字
            return state => {
                return (
                    state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
                );
            };
        },
        handleSelect(item) {
            this.contractMsg.signer = item.id;
            this.contractMsg.signerName = item.name;
            //cosole.log(this.contractMsg.signer)
        },
        //查询合同模板
        getTemplate(value) {
            if (value === true) {
                if (this.houseType) {
                    let params = {
                        templateType: this.houseType
                    };
                    this.$post(queryTemplate, params).then(res => {
                        if (res.success) {
                            this.contractTemplate = res.data;
                        }
                    });
                } else {
                    this.$message({
                        message: "请选择类型",
                        type: "error"
                    });
                }
            }
        },
        //付款方式
        getPayway(value) {
            if (value === true) {
                if (this.houseType) {
                    var storeWay = "";
                    if (this.houseType === "SECONDHAND") {
                        storeWay = BuyPayWay;
                    } else if (this.houseType === "RENTING") {
                        storeWay = RentPayWay;
                    }
                    this.$post(storeWay).then(res => {
                        if (res.success === true) {
                            this.payWay = res.data;
                        }
                    });
                } else {
                    this.$message({
                        message: "请选择类型",
                        type: "error"
                    });
                }
            }
        },
        //证件类型
        getcertificatesType() {
            var params = {
                code: "certificatesType"
            };
            this.$post(dicGet, params).then(res => {
                if (res.success === true) {
                    this.certificatesType = res.data;
                } else {
                    this.$message({
                        type: "error",
                        message: res.msg
                    });
                }
            });
        },
        // 查询婚姻
        getMaritalStatus() {
            let params = { code: "marriage" };
            this.$post(dicGet, params).then(res => {
                if (res.success) {
                    this.marriage = res.data;
                } else {
                    this.$message({
                        message: res.msg,
                        type: "error"
                    });
                }
            });
        },
        //附件上传
        handleAvatarSuccess(res, file) {
            this.contractMsg.picAddress = res.uri;
        },
        /*添加房源*/
        //动态绑定class
        ClassChang1(index) {
            this.residentialAreaId = "";
            this.ResidentialName = "";
            this.isActive1 = index;
            this.pageSize1 = 10;
            this.pageNumber1 = 1;
            this.currentPage1 = 1;
            this.chanceHouse1 = [];
            if (this.isActive1 === 0) {
                this.getAllHouse();
            } else if (this.isActive1 === 1) {
                this.getCollect1();
            }
        },
        clickGethouse() {
            this.pageSize1 = 10;
            this.pageNumber1 = 1;
            this.currentPage1 = 1;
            this.ResidentialName = "";
            this.residentialAreaId = "";
            this.vague = "";
            this.houseNum = "";
            this.houseId = "";
            this.tungId = "";
            this.unitId = "";
            this.isActive1 = 0;
            this.chanceHouse1 = [];
            this.getAllHouse();
        },
        clearArea() {
            this.pageNumber1 = 1;
            this.pageSize1 = 10;
            this.currentPage1 = 1;
            this.ResidentialName = "";
            this.residentialAreaId = "";
            this.tungId = "";
            this.unitId = "";
            this.chanceHouse1 = [];
            if (this.isActive1 === 0) {
                // this.houseNum = "";
                this.getAllHouse();
            } else if (this.isActive1 === 1) {
                // this.vague = "";
                this.getCollect1();
            }
        },
        //查询所有房源
        getAllHouse() {
            this.chanceHouse1 = [];
            if (this.houseType) {
                // 查询房源列表
                this.innerVisible2 = true;
                let level = "";
                let menu = JSON.parse(localStorage.getItem("menu"));
                if (menu)
                    menu.map(item => {
                        if (item.name === "房源管理") {
                            item.childMenus.map(child => {
                                if (
                                    this.houseType === "SECONDHAND" &&
                                    child.name === "二手房"
                                ) {
                                    child.functions.map(func => {
                                        if (func.functionName === "房源查看") {
                                            level = func.level;
                                        }
                                    });
                                } else if (
                                    this.houseType === "RENTING" &&
                                    child.name === "租房"
                                ) {
                                    child.functions.map(func => {
                                        if (func.functionName === "房源查看") {
                                            level = func.level;
                                        }
                                    });
                                }
                            });
                        }
                    });
                var params = {
                    "page.pageNumber": this.pageNumber1 * this.pageSize1 - this.pageSize1,
                    "page.pageSize": this.pageSize1,
                    housingProperty: this.houseType,
                    residentialAreaId: this.residentialAreaId,
                    // cusId: this.customerId,
                    permissionLevel: level
                };
                this.$post(houseQuery, params).then(res => {
                    if (res.success === true) {
                        this.houseAllData1 = res.data;
                        this.total1 = res.total;
                    }
                });
            } else {
                this.$message({
                    message: "请选择类型",
                    type: "error"
                });
            }
        },
        //查询收藏房源
        getCollect1() {
            this.chanceHouse1 = [];
            var params = {
                "page.pageNumber": this.pageNumber1 * this.pageSize1 - this.pageSize1,
                "page.pageSize": this.pageSize1,
                transactionType: this.houseType,
                residentAreaId: this.residentialAreaId,
                type: 2
            };
            this.$post(queryCollections, params).then(res => {
                if (res.success === true) {
                    this.houseAllData1 = res.data.resQueryHousingResourcesDTO;
                    this.total1 = res.total;
                } else {
                    this.$message({
                        type: "error",
                        message: res.msg
                    });
                }
            });
        },
        //分页
        handleCurrentChange1(val) {
            this.pageNumber1 = val;
            if (this.isActive1 === 0) {
                this.getAllHouse();
            } else if (this.isActive1 === 1) {
                this.getCollect1();
            }
        },
        handleSizeChange1(val) {
            this.pageNumber1 = 1;
            this.currentPage1 = 1;
            this.pageSize1 = val;
            if (this.isActive1 === 0) {
                this.getAllHouse();
            } else if (this.isActive1 === 1) {
                this.getCollect1();
            }
        },
        //查询小区
        querySearchAsync1(queryString, cb) {
            // 查询小区
            let params = {
                name: queryString
            };
            this.$post(communityQuery, params).then(res => {
                if (res.success) {
                    this.housingData = res.data;
                    let restaurants = this.housingData;
                    cb(restaurants);
                    this.residentialAreaId = "";
                    this.pageSize1 = 10;
                    this.pageNumber1 = 1;
                    if (this.isActive1 === 0) {
                        this.getAllHouse();
                    } else if (this.isActive1 === 1) {
                        this.getCollect1();
                    }
                }
            });
        },
        createStateFilter1(queryString) {
            // 过滤小区关键字
            return state => {
                return (
                    state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
                );
            };
        },
        handleSelect1(item) {
            this.residentialAreaId = item.residentialAreaId;
            this.ResidentialName = item.name;
            // this.getAllHouse();
        },
        //取消添加房源
        removeSaveBtn() {
            this.innerVisible1 = false;
            this.chanceHouse1 = [];
        },
        save() {
            // console.log(this.chanceHouse1)
            this.houseId = this.chanceHouse1.buildingInfoId;
            this.getHouseDetails();
            this.innerVisible2 = false;
            this.chanceHouse1 = [];
        },
        /*添加客源*/
        //动态绑定class
        ClassChang(index) {
            //   this.string = "";
            this.isActive = index;
            this.pageSize = 10;
            this.pageNumber = 1;
            this.currentPage = 1;
            this.chanceHouse = [];
            if (this.isActive === 0) {
                this.getAllCustomer();
            } else if (this.isActive === 1) {
                this.getCollect();
            }
        },
        getString() {
            this.pageSize = 10;
            this.pageNumber = 1;
            if (this.isActive === 0) {
                this.getAllCustomer();
            } else if (this.isActive === 1) {
                this.getCollect();
            }
        },
        //查询客源收藏
        getCollect() {
            this.chanceHouse = [];
            var housetypes = "";
            if (this.houseType === "SECONDHAND") {
                housetypes = "WANT_TO_BUY";
            } else if (this.houseType === "RENTING") {
                housetypes = "WANT_TO_RENT";
            }
            var params = {
                "page.pageNumber": this.pageNumber * this.pageSize - this.pageSize,
                "page.pageSize": this.pageSize,
                transactionType: housetypes,
                string: this.string
            };
            this.$post(queryCollection, params).then(res => {
                if (res.success === true) {
                    this.houseAllData = res.data.resQueryCustomerDTO;
                    this.total = res.total;
                } else {
                    this.$message({
                        type: "error",
                        message: res.msg
                    });
                }
            });
        },
        clickGetcustomer() {
            this.string = "";
            this.isActive = 0;
            this.getAllCustomer();
        },
        //查询所有客源
        getAllCustomer() {
            this.chanceHouse = [];
            if (this.houseType) {
                this.innerVisible1 = true;
                var housetypes = "";
                if (this.houseType === "SECONDHAND") {
                    housetypes = "WANT_TO_BUY";
                } else if (this.houseType === "RENTING") {
                    housetypes = "WANT_TO_RENT";
                }
                let menu = JSON.parse(localStorage.getItem("menu"));
                if (menu)
                    menu.map(item => {
                        if (item.name === "客源管理") {
                            item.childMenus.map(child => {
                                if (housetypes === "WANT_TO_BUY" && child.name === "求购") {
                                    child.functions.map(func => {
                                        if (func.functionName === "客源查看") {
                                            this.permissionLevel = func.level;
                                        }
                                    });
                                } else if (
                                    housetypes === "WANT_TO_RENT" &&
                                    child.name === "求租"
                                ) {
                                    child.functions.map(func => {
                                        if (func.functionName === "客源查看") {
                                            this.permissionLevel = func.level;
                                        }
                                    });
                                }
                            });
                        }
                    });

                var params = {
                    "page.pageNumber": this.pageNumber * this.pageSize - this.pageSize,
                    "page.pageSize": this.pageSize,
                    transactionType: housetypes,
                    // houseId: this.houseId,
                    string: this.string,
                    permissionLevel: this.permissionLevel
                };
                this.$post(findCustomer, params).then(res => {
                    if (res.success === true) {
                        this.houseAllData = res.data;
                        this.total = res.total;
                    }
                });
            } else {
                this.$message({
                    message: "请选择类型",
                    type: "error"
                });
            }
        },
        //取消添加客源
        removeSaveBtn1() {
            this.innerVisible2 = false;
            this.chanceHouse = {};
        },
        //保存添加客源
        save1() {
            this.innerVisible1 = false;
            // this.customerData = this.chanceHouse;
            //cosole.log(this.chanceHouse);
            this.contractMsg.customerCode = this.chanceHouse.customerId; //客户编号
            this.contractMsg.customerDegree = this.chanceHouse.customerLevel; //客户等级
            this.contractMsg.customerSourceName = this.chanceHouse.source; //客户来源
            this.contractMsg.customerName = this.chanceHouse.name; //客户姓名
            this.contractMsg.customerCardType = this.chanceHouse.certificatesType; //客户证件类型
            this.contractMsg.customerCard = this.chanceHouse.idCard; //客户证件号
            this.contractMsg.customerPhone = this.chanceHouse.phoneNumber; //客户电话
            this.chanceHouse = {};
        },
        getHouseDetails() {
            let params = {
                buildingInfoId: this.houseId,
                employeeId: sessionStorage.getItem("employeeId")
            };
            this.$post(houseTypeDetail, params).then(res => {
                if (res.success) {
                    this.housingInfo = res.data;
                    this.contractMsg.houseCode = this.housingInfo.buildingInfoId; //房屋编号
                    if (this.houseType === "SECONDHAND") {
                        this.contractMsg.floorSpace = this.housingInfo.areaOfBuilding; //二手建筑面积
                    } else if (this.houseType === "RENTING") {
                        this.contractMsg.floorSpace = this.housingInfo.rentalArea; //租房建筑面积
                    }
                    this.contractMsg.titleCertificate = this.housingInfo.estateCertificationNo; //产权证号
                    this.contractMsg.houseAddr =
                        this.housingInfo.areaName +
                        this.housingInfo.residentialAreaName +
                        this.housingInfo.tung +
                        this.housingInfo.unit +
                        this.housingInfo.floor +
                        this.housingInfo.roomNumber; //房源地址
                    this.contractMsg.ownerName = this.housingInfo.name; //业主姓名
                    this.contractMsg.ownerCardType = this.housingInfo.idType; //业主证件类型
                    this.contractMsg.ownerCard = this.housingInfo.idNumber; //业主证件号
                    this.contractMsg.ownerPhone = this.housingInfo.phone; //业主电话
                    this.contractMsg.communicationAddr = this.housingInfo.address; //业主地址
                    // this.contractMsg.jointOwner = this.housingInfo.partOwnerName; //业主共有人姓名
                    // this.contractMsg.jointCardType = this.housingInfo.partOwnerIdType; //业主共有人证件类型
                    // this.contractMsg.jointCard = this.housingInfo.partOwnerIdNumber; //业主共有人证件号
                    // this.contractMsg.jointPhone = this.housingInfo.partOwnerPhone; //业主共有人电话
                    if (this.housingInfo.partOwnerInfo.length === 0) {
                        this.contractMsg.partOwnerInfo = [
                            { name: "", phone: [], idType: "", idNumber: "", address: "" }
                        ];
                    } else {
                        this.contractMsg.partOwnerInfo = this.housingInfo.partOwnerInfo;
                    }

                    this.contractMsg.usrArea = this.housingInfo.areaOfUse; //套内面积
                    this.contractMsg.ownerMarriage = this.housingInfo.marriage; //婚姻
                    if (this.houseType === "SECONDHAND") {
                        this.contractMsg.contractType = "1";
                    } else if (this.houseType === "RENTING") {
                        this.contractMsg.contractType = "2";
                    } //类型
                }
            });
        },
        //判断新增编辑
        addOrwrite() {
            //新增
            // if (
            //     this.addType == 0 &&
            //     sessionStorage.getItem("concractFrom") !== "contracList"
            // ) {
            //     // this.$route.name = '合同录入';
            //     this.getHouseDetails();
            //     this.isdisabled = true;
            // }
            // if (this.addType == 1) {
            // this.$route.name = '合同编辑';
            this.isdisabled = true;
            this.contractMsg = this.contractMsgs;
            this.contractMsg.houseCode = this.contractMsgs.houseInfoId;
            if (this.contractMsg.partOwnerInfo.length === 0) {
                this.contractMsg.partOwnerInfo = [
                    { name: "", phone: [], idType: "", idNumber: "", address: "" }
                ];
            }
            if (this.contractMsg.ownerClientPhone) {
                this.contractMsg.ownerClientPhone = this.contractMsg.ownerClientPhone.split(
                    ","
                );
            } else {
                this.contractMsg.ownerClientPhone = [""];
            }
            if (this.contractMsg.customerJointPhone) {
                this.contractMsg.customerJointPhone = this.contractMsg.customerJointPhone.split(
                    ","
                );
            } else {
                this.contractMsg.customerJointPhone = [""];
            }
            if (this.contractMsg.cusJointPhone) {
                this.contractMsg.cusJointPhone = this.contractMsg.cusJointPhone.split(
                    ","
                );
            } else {
                this.contractMsg.cusJointPhone = [""];
            }
            this.contractMsg.oldPaymentMethod = sessionStorage.getItem(
                "oldPaymentMethod"
            );
            //  //cosole.log(this.contractMsg)
            //  //cosole.log(this.$route.name);
            if (this.houseType === "SECONDHAND") {
                this.contractMsg.contractType = "1";
            } else if (this.houseType === "RENTING") {
                this.contractMsg.contractType = "2";
            } //类型
            console.log(this.houseType)
            this.getTemplate(true);
            this.getPayway(true);
            // }
        },
        //判断出租出售
        isShow() {
            //  //cosole.log(this.houseType);
            if (this.houseType === "SECONDHAND") {
                this.typeShow = true;
                this.sentShow = false;
            } else if (this.houseType === "RENTING") {
                this.typeShow = false;
                this.sentShow = true;
            }
            //cosole.log(this.typeShow);
            //cosole.log(this.sentShow)
        },

        //合同录入
        enter() {
            let params = Object.assign({}, this.contractMsg);
            let url = "";
            if (this.addType == 0) {
                url = add;
            } else if (this.addType == 1) {
                url = update;
            }
            if (!this.contractMsg.contractCode) {
                this.$message({
                    type: "error",
                    message: "请输入合同编号"
                });
                return;
            }
            if (!this.contractMsg.contractType) {
                this.$message({
                    type: "error",
                    message: "请选择类型"
                });
                return;
            }
            if (!this.contractMsg.signer) {
                this.$message({
                    type: "error",
                    message: "请选择签约人"
                });
                return;
            }
            if (!this.contractMsg.signDate) {
                this.$message({
                    type: "error",
                    message: "请选择签约日期"
                });
                return;
            }
            if (!this.contractMsg.templateId) {
                this.$message({
                    type: "error",
                    message: "请选择合同模板"
                });
                return;
            }
            if (!this.contractMsg.finalPrice) {
                this.$message({
                    type: "error",
                    message: "请输入成交金额"
                });
                return;
            }
            if (!this.contractMsg.paymentMethod) {
                this.$message({
                    type: "error",
                    message: "请选择付款方式"
                });
                return;
            }
            if (
                !this.contractMsg.ownerName ||
                !this.contractMsg.ownerCardType ||
                !this.contractMsg.ownerCard ||
                !this.contractMsg.ownerPhone
            ) {
                this.$message({
                    type: "error",
                    message: "请完善业主信息"
                });
                return;
            }
            if (
                !this.contractMsg.customerCode ||
                !this.contractMsg.customerName ||
                !this.contractMsg.customerCardType ||
                !this.contractMsg.customerCard ||
                !this.contractMsg.customerPhone
            ) {
                this.$message({
                    type: "error",
                    message: "请完善客户信息"
                });
                return;
            }
            //业主委托人电话
            for (let i = this.contractMsg.ownerClientPhone.length - 1; i >= 0; i--) {
                if (i !== 0 && this.contractMsg.ownerClientPhone[i] === "") {
                    this.contractMsg.ownerClientPhone.splice(i, 1);
                }
            }
            if (params.ownerClientPhone) {
                params.ownerClientPhone = params.ownerClientPhone.join(",");
            }
            //客户共有人电话
            for (
                let i = this.contractMsg.customerJointPhone.length - 1;
                i >= 0;
                i--
            ) {
                if (i !== 0 && this.contractMsg.customerJointPhone[i] === "") {
                    this.contractMsg.customerJointPhone.splice(i, 1);
                }
            }
            if (params.customerJointPhone) {
                params.customerJointPhone = params.customerJointPhone.join(",");
            }
            //客户委托人电话
            for (let i = this.contractMsg.cusJointPhone.length - 1; i >= 0; i--) {
                if (i !== 0 && this.contractMsg.cusJointPhone[i] === "") {
                    this.contractMsg.cusJointPhone.splice(i, 1);
                }
            }
            if (params.cusJointPhone) {
                params.cusJointPhone = params.cusJointPhone.join(",");
            }
            this.$post(url, params).then(res => {
                if (res.success === true) {
                    this.$message({
                        type: "success",
                        message: res.msg
                    });
                    if (url === add) {
                        this.$router.push("/contracList");
                    } else if (url === update) {
                        this.$router.push('/contractDetails');
                    }
                    this.$store.commit("delete_tabs", "/contractRedact");
                    // this.$store.commit("delete_clude", "合同录入");
                } else {
                    this.$message({
                        type: "error",
                        message: res.msg
                    });
                }
            });
        },
        //取消
        back() {
            this.$router.go(-1);
        },
        //分页
        handleCurrentChange(val) {
            this.pageNumber = val;
            if (this.isActive === 0) {
                this.getAllCustomer();
            } else if (this.isActive === 1) {
                this.getCollect();
            }
        },
        handleSizeChange(val) {
            this.pageNumber = 1;
            this.currentPage = 1;
            this.pageSize = val;
            if (this.isActive === 0) {
                this.getAllCustomer();
            } else if (this.isActive === 1) {
                this.getCollect();
            }
        }
    },
    created() {
        this.getcertificatesType();
        this.getMaritalStatus();
        this.addOrwrite();
        this.isShow();
    }
};
</script>
<style lang="less" >
.contract-box {
    .el-icon-date {
        display: none;
    }
    .el-input {
        width: auto;
        .el-input__inner {
            border: none !important;
            height: 19px;
            line-height: 19px !important;
            min-width: 80px;
            padding-right: 20px;
            padding-left: 0;
        }
    }
    .el-select {
        .el-input__inner {
            padding-right: 44px;
        }
    }
    .el-input__icon {
        line-height: 19px !important;
    }
    .el-textarea__inner {
        border: none;
        padding: 5px;
        resize: none;
    }
    .el-select {
        .el-input__inner {
            width: 100px;
            min-width: 80px;
            padding-right: 30px;
        }
    }
    .address {
        width: 100%;
        .el-input__inner {
            width: 100%;
            min-width: 80px;
        }
    }
    .input-iphone {
        .el-input__inner {
            width: 100px;
            padding-right: 5px;
        }
    }
    .zhengjian {
        .el-select {
            .el-input {
                .el-input__inner {
                    width: 80px !important;
                }
            }
        }
    }
}

.contract-box .mask .el-carousel__item {
    background: transparent;
    opacity: 1 !important;
}
.contract-box .mask {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: 9;
    .close {
        width: 20px;
        position: absolute;
        top: 0px;
        right: 300px;
        padding: 50px;
        z-index: 100;
    }
    .delet {
        position: absolute;
        padding-left: 36px;
        padding-right: 36px;
        bottom: 0;
        right: 100px;
        z-index: 100;
        height: auto !important;
    }
    .download {
        border: none;
        background: #22ca85;
        color: #ffffff;
        position: absolute;
        padding-left: 36px;
        padding-right: 36px;
        bottom: 0;
        right: 250px;
        z-index: 100;
        height: auto !important;
    }
    .edit {
        position: absolute;
        padding-left: 36px;
        padding-right: 36px;
        bottom: 0;
        right: 240px;
        z-index: 100;
        height: auto !important;
    }

    .el-carousel__container {
        margin: 0 auto;
        width: 80%;
        height: 90vh;
        z-index: 99;
        .el-carousel__arrow {
            font-size: 50px !important;
            padding: 20px;
            width: 100px;
            height: 100px;
        }
        // .el-carousel__arrow--left,.el-carousel__arrow--right{

        // }
    }

    .el-carousel__item {
        color: #475669;
        font-size: 18px;
        opacity: 0.75;
        margin: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        // min-height: 400px;
        .uploadtime {
            width: 100%;
            line-height: 24px;
            color: #fff;
            position: absolute;
            left: 100px;
            bottom: 0;
        }
        > img {
            height: 90%;
        }
    }
    .door_modle_introduced {
        margin-top: 20px;
        display: flex;
        justify-content: space-between;
        padding: 0 100px;
        .introduced_toward {
            display: flex;
            flex-direction: column;
            > span {
                font-size: 14px;
                color: #ffffff;
            }

            .el-textarea {
                margin-top: 10px;
                .el-textarea__inner {
                    width: 260px;
                    height: 60px;
                    background: #f5f5f5;
                    border: 1px solid #ccc;
                }
            }
        }
        .el-select {
            margin-top: 10px;
            .el-input {
                .el-input__inner {
                    padding-left: 10px !important;
                    font-size: 16px !important;
                    width: 100px !important;
                    height: 30px !important;
                    background: #f5f5f5;
                    border: 1px solid #ccc !important;
                }
                .el-input__icon {
                    line-height: 30px;
                }
            }
        }
    }

    // .el-carousel__item:nth-child(2n) {
    //   background-color: #99a9bf;
    // }

    // .el-carousel__item:nth-child(2n+1) {
    //   background-color: #d3dce6;
    // }
}
.customerselete {
    .header-select-input {
        width: 200px !important;
        .el-input {
            width: 200px !important;
        }
        .el-input__inner {
            width: 200px !important;
        }
    }
}
</style>
<style lang="less" scoped>
.contract-box {
    margin: 14px 0 14px 14px;
}
.contract_wrap {
    background: #ffffff;
    padding: 26px;
    &_item {
        border: 1px solid #e1e1e1;
        &_title {
            color: #333333;
            display: flex;
            align-items: center;
            font-size: 16px;
            font-weight: bold;
            padding: 12px 17px;
            background: #f2f4ff;
            .icon {
                width: 6px;
                height: 16px;
                background: rgba(94, 117, 230, 1);
                border-radius: 3px;
                margin-right: 10px;
            }
            span {
                font-weight: bold;
            }
        }
        &_content {
            &_item {
                display: flex;
                justify-content: flex-start;
                color: #333333;
                font-size: 14px;
                padding: 10px 20px 10px 0;
                border-bottom: 1px solid #e1e1e1;
                .column {
                    width: 20%;
                    padding-left: 20px;
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    .text {
                        color: #333333;
                        > span:last-child {
                            display: inline-block;
                            min-width: 70px;
                        }
                    }
                }
            }
            &_item:last-child {
                border-bottom: none;
            }
        }
    }
    &_item:nth-child(2),
    &_item:nth-child(3) {
        .contract_wrap_item_content {
            &_item {
                padding: 0;
                &_title {
                    width: 110px;
                    text-align: center;
                    font-weight: bold;
                    border-right: 1px solid #e1e1e1;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                &_msg {
                    width: 100%;
                    &_item {
                        display: flex;
                        justify-content: flex-start;
                        align-items: center;
                        padding: 10px 0;
                        border-bottom: 1px solid #e1e1e1;
                        .column:nth-child(2) {
                            width: 29%;
                        }
                        .column:nth-child(3) {
                            width: 21%;
                        }
                        .column:nth-child(4) {
                            width: 34%;
                        }
                        .column:first-child {
                            width: 15%;
                        }
                    }
                    &_item:last-child {
                        border: none;
                    }
                }
            }
        }
    }
}

.txthidden {
    visibility: hidden;
}
.must {
    color: red;
    vertical-align: middle;
    margin-right: 2px;
}
.foot {
    text-align: right;
    padding: 30px 0;
    /*background: #ffffff;*/
    padding-right: 30px;
    margin-right: 0 !important;
}
// .cancel,
// .save {
//     width: 80px;
//     height: 40px;
//     border: none;
//     border-radius: 4px;
//     color: #ffffff;
//     background: #999999;
//     font-size: 16px;
// }
.save {
    margin-left: 30px;
    background: #5e75e6;
}
/*带看房源*/
.newintention-wrapper1 {
    width: 800px;
    margin: 0 auto;
    position: relative;
    top: -20px;
}
.list-out {
    background: #ffffff;
    padding-bottom: 10px;
    margin-top: 30px;
}
.header-select {
    display: flex;
    justify-content: flex-start;
    margin-bottom: 15px;
}

.header-select-input {
    background: #f5f5f5;
    width: 175px;
    height: 30px;
    margin-bottom: 10px;
    margin-right: 20px;
}
.btn {
    width: 80px;
    height: 30px;
    border: none;
    outline: none;
    border-radius: 4px;
    font-size: 14px;
}
.reset {
    background: #cccccc;
    color: #666666;
}
.query {
    background: #5e75e6;
    color: #ffffff;
}
.reset-out {
    margin-bottom: 10px;
}
.footb {
    text-align: right;
    margin-top: 70px;
    padding: 20px 0;
    background: #f5f5f5;
}
.foot-cancel,
.foot-save {
    width: 80px;
    height: 40px;
    border: none;
    outline: none;
    border-radius: 4px;
    font-size: 16px;
    color: #ffffff;
    margin-right: 20px;
}
.foot-cancel {
    background: #cccccc;
}
.foot-save {
    background: #5e75e6;
}
.footer_page {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
    margin-bottom: 20px;

    .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #5e75e6;
    }

    .el-pagination.is-background .btn-next,
    .el-pagination.is-background .btn-prev,
    .el-pagination.is-background .el-pager li {
        border: 1px solid #ccc;
        background: white;
    }
}
.list-out-tab {
    font-size: 20px;
    color: #999999;
    margin-bottom: 30px;
}
.list-out-tab span {
    margin-right: 30px;
    cursor: pointer;
}
.active {
    color: #5e75e6;
}
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
}
.avatar {
    width: 100px;
    height: 100px;
    display: block;
}
</style>


